import Rate from './Rate';

export default Rate;


//////////////////
// WEBPACK FOOTER
// ./~/element-react/dist/npm/es6/src/rate/index.js
// module id = 423
// module chunks = 0